import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-diretion: row;
    align-items: center;
    justify-content: center;
`;
